import React from 'react'
import { ActivityIndicator, TouchableOpacity, View } from 'react-native'

import tw from '../styles/tailwind'
import Text from './Text'
import type { AccessServiceType } from '../hooks/useAccessServiceTypes'


/**
 * Lista de radios con el catálogo de servicios, para los formularios de admin y vigilancia. El
 * residente tiene su propio paso a pantalla completa en NewAccessAuthorizationModal.
 */
export default function AccessServiceTypePicker({ types, value, onChange, isLoading }: {
  types: AccessServiceType[];
  value?: string | null;
  onChange: (uuid: string) => void;
  isLoading?: boolean;
}) {
  if (isLoading) return <ActivityIndicator style={tw`my-4`} />

  if (types.length === 0) {
    return <Text style={tw`text-amber-600 text-sm mb-5`}>El catálogo de servicios está vacío. Agrega tipos en la configuración de autorizaciones.</Text>
  }

  return (
    <View style={tw`border border-gray-200 rounded-lg mb-5`}>
      {types.map((t, i) => {
        const active = value === t.uuid
        return (
          <TouchableOpacity
            key={t.uuid}
            onPress={() => onChange(t.uuid)}
            style={tw.style(`flex-row px-3 py-2.5`, i > 0 && `border-t border-gray-100`, active && `bg-primary/5`)}
          >
            <View style={tw.style(`w-5 h-5 rounded-full border-2 mr-3 mt-0.5 items-center justify-center`, active ? `border-primary` : `border-gray-300`)}>
              {active && <View style={tw`w-2.5 h-2.5 rounded-full bg-primary`} />}
            </View>
            <View style={tw`flex-1`}>
              <Text style={tw.style(`font-500`, active ? `text-primary` : `text-gray-700`)}>{t.name}</Text>
              {!!t.description && <Text style={tw`text-gray-500 text-sm`}>{t.description}</Text>}
            </View>
          </TouchableOpacity>
        )
      })}
    </View>
  )
}
